module.exports = __webpack_public_path__ + "static/media/apple-mac.d975e48c.png";